import Entity from './Entity';

export default class EpisodeViewerErrorLog implements Entity {
  constructor(public id: number) {}
}
